import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=5ac1f402&scoped=true"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1f402",
  null
  
)

export default component.exports